import { Stack, Title, Text } from '@repletoryreach/sdk-ui';
import { Link } from 'react-router-dom';
import { LoginForm } from './components/LoginForm';
import { SocialButtons } from '../components/SocialButtons';
import { useT } from '../../../i18n/I18nProvider';

export default function LoginPage() {
  const t = useT();
  return (
    <Stack gap="lg">
      <Stack gap="xs">
        <Title order={1}>{t('auth.login.title')}</Title>
        <Text role="bodySmall" c="var(--rr-color-text-muted)">
          {t('auth.login.description')}
        </Text>
      </Stack>
      <LoginForm />
      <SocialButtons />
      <Text role="caption" c="var(--rr-color-text-muted)">
        {t('auth.login.newHere')} <Link to="/auth/signup">{t('auth.login.createAccount')}</Link>
      </Text>
    </Stack>
  );
}
